import { Box, Chip } from "@mui/material";
import FiberManualRecord from "@mui/icons-material/FiberManualRecord";

/** Pill-style status (no leading dot); use where the compact chip is not desired. */
export function StartTrackingStatusPill({ status }) {
  const isOnTrack = /^on track$/i.test(status);
  return (
    <Box
      component="span"
      role="status"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 9999,
        px: 1.75,
        py: 0.5,
        bgcolor: isOnTrack ? "#E3F5EC" : "#FFE8E8",
        color: isOnTrack ? "#0F766E" : "#B91C1C",
        fontSize: 12,
        fontWeight: 500,
        lineHeight: 1.25,
        letterSpacing: "0.01em",
      }}
    >
      {status}
    </Box>
  );
}

export default function StartTrackingStatusChip({ status }) {
  const isOnTrack = /^on track$/i.test(status);
  return (
    <Chip
      size="small"
      variant="outlined"
      icon={<FiberManualRecord />}
      label={status}
      sx={{
        borderRadius: 12,
        pl: "2px",
        pr: "2px",
        bgcolor: isOnTrack ? "#E6FFE9" : "#FFE2E2",
        border: "none",
        "& .MuiChip-label, & .MuiChip-labelSmall": {
          px: 1,
          fontSize: "12px",
          lineHeight: "1.4",
          fontWeight: 600,
        },
        "& .MuiChip-icon": { color: isOnTrack ? "#128A20" : "#FF3636" },
      }}
    />
  );
}
